import imageCompression from 'browser-image-compression';

const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

export async function compressIfImage(file: File): Promise<File> {
  if (!IMAGE_TYPES.includes(file.type)) return file;

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: 'image/jpeg' as const,
  };

  try {
    const compressed = await imageCompression(file, options);
    return new File([compressed], file.name.replace(/\.[^.]+$/, '.jpg'), {
      type: 'image/jpeg',
      lastModified: Date.now()
    });
  } catch {
    return file;
  }
}

export function isImage(mime: string): boolean {
  return mime.startsWith('image/');
}

export function isPDF(mime: string): boolean {
  return mime === 'application/pdf';
}
